import { action, props } from 'ts-action';
import { SkipHistory } from '../../undo/actions/undo.actions';
import { MenuSearchBoxOption } from '@cdl/heartbeat-react';
import {
  AnnotationTask,
  Annotator,
} from '../../ecg/types/annotation-tasks.type';

export const loadActive = action(
  '[Admin] Load Active Annotation Tasks',
  props<{
    activeAnnotationTasks: AnnotationTask[];
    currentPage: number;
  }>(),
);

export const loadInactive = action(
  '[Admin] Load Inactive Annotation Tasks',
  props<{
    inactiveAnnotationTasks: AnnotationTask[];
    currentPage: number;
  }>(),
);

export const setActiveTasksPage = action(
  '[Admin] Set active tasks page',
  props<{
    page: number;
  }>(),
);

export const setInactiveTasksPage = action(
  '[Admin] Set inactive tasks page',
  props<{
    page: number;
  }>(),
);

export const handleParams = action(
  '[Admin] Handle params for Annotation Tasks',
  props<{
    param: string;
    value: string | string[];
  }>(),
);

export const update = action(
  '[Admin] Update Annotation Task Status',
  props<
    {
      annotationTask: AnnotationTask;
      status: string;
    } & SkipHistory
  >(),
);

export const setAnnotatorsList = action(
  '[Admin] Set annotators list',
  props<{
    annotatorsList: Annotator[];
  }>(),
);

export const setAnnotationGridsList = action(
  '[Admin] Set grid list',
  props<{
    annotationGridsList: MenuSearchBoxOption[];
  }>(),
);

export const setIsLoading = action(
  '[Admin] Set is loading',
  props<{
    isLoading: boolean;
  }>(),
);

export const addNewTask = action(
  '[Annotation Tasks] Add new task',
  props<{ newtask: AnnotationTask } & SkipHistory>(),
);
